// apps/web/src/components/help/HelpCenter.tsx
// Help and support center component

import { useState } from 'react';

export function HelpCenter() {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');

  const categories = [
    { id: 'getting-started', name: 'Getting Started', icon: '🚀' },
    { id: 'campaigns', name: 'Campaigns', icon: '📊' },
    { id: 'creators', name: 'Creators', icon: '👥' },
    { id: 'content', name: 'Content', icon: '📁' },
    { id: 'finance', name: 'Finance', icon: '💰' },
    { id: 'security', name: 'Security', icon: '🔒' },
    { id: 'troubleshooting', name: 'Troubleshooting', icon: '🔧' },
    { id: 'api', name: 'API Reference', icon: '💻' },
  ];

  const faqs = [
    { 
      id: 'faq1', 
      question: 'How do I create a new campaign?', 
      answer: 'To create a new campaign, navigate to the Campaigns section and click "Create Campaign". Fill in the campaign details and select your target audience.', 
      category: 'campaigns' 
    },
    { 
      id: 'faq2', 
      question: 'How do I add a creator to my platform?', 
      answer: 'Go to the Creators section and click "Add Creator". Enter the creator\'s details and select their creator type.', 
      category: 'creators' 
    },
    { 
      id: 'faq3', 
      question: 'How do I manage my billing information?', 
      answer: 'Visit the Finance section and select "Billing". You can update your payment methods and view your billing history here.', 
      category: 'finance' 
    },
    { 
      id: 'faq4', 
      question: 'What are the platform\'s security measures?', 
      answer: 'Our platform uses industry-standard security measures including 256-bit encryption, secure authentication, and regular security audits.', 
      category: 'security' 
    },
  ];

  const filteredFaqs = faqs.filter(faq => 
    faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
    faq.answer.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (faq.category && categories.find(c => c.id === faq.category)?.name.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <div className="help-center">
      <div className="header">
        <h2>Help Center</h2>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search help articles..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="help-content">
        <div className="categories-sidebar">
          <h3>Categories</h3>
          <ul>
            {categories.map(category => (
              <li key={category.id}>
                <button
                  type="button"
                  className={`category-button ${activeCategory === category.id ? 'active' : ''}`}
                  onClick={() => setActiveCategory(category.id === activeCategory ? null : category.id)}
                >
                  <span className="category-icon">{category.icon}</span>
                  {category.name}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="faq-content">
          <h3>Frequently Asked Questions</h3>
          {filteredFaqs.length > 0 ? (
            <div className="faq-list">
              {filteredFaqs.map(faq => (
                <div key={faq.id} className="faq-item">
                  <h4>{faq.question}</h4>
                  <p>{faq.answer}</p>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-results">
              <p>No FAQs found matching your search.</p>
            </div>
          )}
        </div>
      </div>

      <div className="support-actions">
        <h3>Need More Help?</h3>
        <div className="support-buttons">
          <button className="btn btn-primary">Contact Support</button>
          <button className="btn btn-outline">Live Chat</button>
          <button className="btn btn-outline">Submit Ticket</button>
        </div>
      </div>
    </div>
  );
}